
import { Component, Vue, Prop } from "vue-property-decorator";
import { safeRepeat } from "@/utils/string-utils";

@Component({})
export default class RaiseTitle extends Vue {
	@Prop() titleList: string[];

	private buildTitleString(title: string, idx: number) {
		if (idx === 0) {
			return title;
		}
		return `${safeRepeat("\xa0\xa0", idx)}└─${title}`;
	}


}
